<template>
    <app-modal :modal-id="modalId" :preloader="preloader" @close-modal="closeModal" modal-size="default">
        <template slot="header">
            <h5 class="modal-title" id="exampleModalLabel">
                Nouvel Evenement du Lot {{ truckData.lot_number }} - Horse {{ truckData.horse }}
            </h5>
            <button type="button" class="close outline-none" @click.prevent="closeModal">
                <span class="mb-1">
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>
        <template slot="body">
            <app-overlay-loader v-if="preloader" />
            <form class="mb-0" :class="{ 'loading-opacity': preloader }" ref="form"
                data-url=''>
                <div class="row">
                    <div class="col-md-12">
                        <!-- Location Select Input -->
                        <div class="form-group">
                            <label for="location">{{ $t('location') }} <span style="color: crimson">*</span></label>
                            <div class="d-flex align-items-center w-100">
                                <app-input class="w-100" id="location" v-model="inputs.location_id"
                                    :list="locationList" list-value-field="name" :placeholder="$t('choose_a_location')"
                                    type="search-select" :required="true"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <!-- Status Select Input -->
                        <div class="form-group">
                            <label for="status">{{ $t('status') }} <span style="color: crimson">*</span></label>
                            <div class="d-flex align-items-center w-100">
                                <app-input class="w-100" id="status" v-model="inputs.status_id"
                                    :list="statusList" list-value-field="name" :placeholder="$t('choose_a_status')"
                                    type="search-select" :required="true"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <!-- Escorter Select Input -->
                        <div class="form-group">
                            <label for="escorter">{{ $t('escorter') }} <span style="color: crimson">*</span></label>
                            <div class="d-flex align-items-center w-100">
                                <app-input class="w-100" id="escorter" v-model="inputs.escorter_id"
                                    :list="escorterList" list-value-field="name" :placeholder="$t('choose_a_escorter')"
                                    type="search-select"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <!-- Date Picker Input -->
                        <div class="form-group">
                            <label for="event_date">{{ $t('event_date') }} <span style="color: crimson">*</span></label>
                            <div class="d-flex align-items-center w-100">
                                <app-input class="w-100" id="event_date" v-model="inputs.event_date" type="date" :required="true"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <!-- Time Picker Input -->
                        <div class="form-group">
                            <label for="event_time">{{ $t('event_time') }} <span style="color: crimson">*</span></label>
                            <div class="d-flex align-items-center w-100">
                                <app-input class="w-100" id="event_time" v-model="inputs.event_time" type="time" :required="true"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <!-- Comment TextArea Input -->
                        <div class="form-group">
                            <label for="inputs_comment">{{ $t('comment') }}</label>
                            <app-input id="inputs_comment" type="text" v-model="inputs.comment"
                                :placeholder="$t('comment')" />
                        </div>
                    </div>
                </div>
            </form>
        </template>
        <template slot="footer">
            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal" @click="closeModal">
                {{ $t('cancel') }}
            </button>
            <button type="button" class="btn btn-primary" @click="submit" :disabled="disabled">
                {{ $t('save') }}
            </button>
        </template>
    </app-modal>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import { FormMixin } from '../../../../core/mixins/form/FormMixin';
import { TRACKING } from '../../../Config/ApiUrl';
import { ModalMixin } from '../../../Mixins/ModalMixin';

export default {
    name: 'AddTruckEventModal',
    mixins: [FormMixin, ModalMixin],
    props: {
        tableId: {
            type: String,
        },
        truckData: {
            type: Object,
        },
    },
    computed: {
        ...mapState({
            locationList: state => state.selects.locationList,
            statusList: state => state.selects.statusList,
            escorterList: state => state.selects.escorterList,
        }),
        disabled() {
            return this.inputs.location_id == this.truckData.location_id &&
                    this.inputs.status_id == this.truckData.status_id &&
                    this.inputs.escorter_id == this.truckData.escorter_id && this.inputs.event_time == null;
        }
    },
    data() {
        return {
            inputs: {
                trip_id: null,
                location_id: null,
                status_id: null,
                escorter_id: null,
                comment: null,
                event_date: moment().format('YYYY-MM-DD'),
                event_time: moment().format('HH:mm'),
                moment: null,
            },
            preloader: false,
            modalId: 'add-truck-event-modal',
            isModalActive: false,
        }
    },
    methods: {
        submit() {
            if (!this.inputs.event_time) {
                this.$toastr.e(this.$t('event_time') + ' ' + this.$t('is_required'));
                return;
            }

            this.preloader = true;
            const url = TRACKING;
            this.inputs.event_date = moment(this.inputs.event_date).format('YYYY-MM-DD');
            this.inputs.moment = `${this.inputs.event_date} ${this.inputs.event_time}`;
            this.axiosPost({ url, data: this.inputs }).then(response => {
                this.$toastr.s(response.data.message);
                this.$hub.$emit('reload-' + this.tableId);
                this.closeModal();
            }).catch(({ response }) => {
                this.$toastr.e(response?.data?.message || this.$t('something_went_wrong'));
            }).finally(() => {
                this.preloader = false;
            });
        },
    },
    mounted() {
        this.inputs.trip_id = this.truckData.trip_id;
        this.inputs.location_id = this.truckData.location_id;
        this.inputs.status_id = this.truckData.status_id;
        this.inputs.escorter_id = this.truckData.escorter_id;
        this.$store.dispatch('getLocations');
        this.$store.dispatch('getEscorters');
        this.$store.dispatch('getStatus');
    }
}
</script>

<style></style>
